import { ApiErrorCode, isApiResponseError, TFClient } from "tf-api-client";
import {
  ACCESS_TOKEN_KEY,
  API_BASE_PATH,
  REFRESH_TOKEN_KEY,
} from "./config/constants";
import { sessionEvents } from "./services/session-events";

const api = new TFClient({
  baseUrl: API_BASE_PATH,
  getAccessToken: async () => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (!token) {
      return null;
    }
    return token;
  },
  setAccessToken: async (token: string) => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },
  getRefreshToken: async () => {
    const token = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (!token) {
      return null;
    }
    return token;
  },
  setRefreshToken: async (token: string) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  },

  // The SDK de-duplicates refreshes and retries a 401 once, so no retry logic
  // belongs here. These hooks only report to the session handler.
  onError: (error, context) => {
    if (context.isTokenRefresh) {
      return sessionEvents.emit({ type: "refreshFailed", error });
    }

    // The login screen handles its own errors (including 403
    // `organization_frozen`).
    if (context.endpoint.startsWith("/auth/")) {
      return;
    }

    if (!isApiResponseError(error)) {
      return;
    }

    if (error.is(ApiErrorCode.OrganizationFrozen)) {
      return sessionEvents.emit({
        type: "organizationFrozen",
        endpoint: context.endpoint,
      });
    }

    if (error.is(ApiErrorCode.OrganizationOnboardingIncomplete)) {
      return sessionEvents.emit({ type: "onboardingIncomplete" });
    }

    // Still 401 after the SDK refreshed the tokens and retried once.
    if (error.status === 401) {
      return sessionEvents.emit({ type: "unauthenticated" });
    }
  },
  onTokensRefreshed: (tokens) =>
    sessionEvents.emit({ type: "tokensRefreshed", ...tokens }),
});

export default api;
